import React, { FC } from 'react';

import i18n from 'i18n';
import { ModalProps } from '../types';
import Modal from '../../Modal/index';

interface WaitModalProps extends ModalProps {

}

export const WaitModal: FC<WaitModalProps> = ({ onCancel, onSuccess }) => (
  <Modal
    id="WaitModal"
    title={i18n('page.Clock.InstallButtonWaitModal.title')()}
    contentAbove={i18n('page.Clock.InstallButtonWaitModal.content')()}
    buttons={[
      {
        id: 'wait-modal-ok',
        text: i18n('page.Clock.InstallButtonWaitModal.button')(),
        onClick: onCancel
      }
    ]}
    onClose={onSuccess}
  />
);